import { render, staticRenderFns } from "./DashboardProfileCard.vue?vue&type=template&id=7b9c9470&scoped=true"
import script from "./DashboardProfileCard.vue?vue&type=script&lang=js"
export * from "./DashboardProfileCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardProfileCard.vue?vue&type=style&index=0&id=7b9c9470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c9470",
  null
  
)

export default component.exports